import React from 'react'
import { IProps } from './index'
import { Text } from 'marketing-site/src/library/elements/Text'
import { Color, mq } from '../../utils'
import { useModeToggle } from '../../providers/toggleProvider'
import { ImageOrAutoplayVideo } from '../ImageOrAutoplayVideo'

const SupportSpotlightFeaturedCard: React.FC<IProps> = ({
  eyebrow,
  title,
  description,
  video,
  fallbackImageRef,
  legend,
}) => {
  const { mode } = useModeToggle()
  return (
    <>
      <div
        className="support-spotlight-featured-card"
        data-testid="support-spotlight-featured-card"
      >
        <div className="support-spotlight-featured-card__left-side">
          <ImageOrAutoplayVideo video={video} imageRef={fallbackImageRef} forcePoster />
        </div>
        <div className="support-spotlight-featured-card__right-side">
          {eyebrow ? (
            <div className="support-spotlight-featured-card__eyebrow">
              <Text brand="default" size="eyebrows">
                {eyebrow}
              </Text>
            </div>
          ) : null}
          <div className="support-spotlight-featured-card__body">
            <div className="support-spotlight-featured-card__title">
              <Text brand="default" size="heading-4-bold">
                {title}
              </Text>
            </div>
            <div className="support-spotlight-featured-card__description">
              <Text brand="default" size="body">
                {description}
              </Text>
            </div>
            {legend ? (
              <div className="support-spotlight-featured-card__legend">
                <Text brand="default" size="body">
                  {legend}
                </Text>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <style jsx>{`
        .support-spotlight-featured-card {
          display: flex;
          width: 100%;
          flex-direction: column;
          border: ${mode.cardBorder ?? `2px solid ${Color.Gray}`};
          border-radius: 1.5625rem;
          overflow: hidden;

          &__left-side,
          &__right-side {
            flex: 1 0 50%;
            background-color: $white;
          }

          &__right-side {
            display: flex;
            flex-wrap: wrap;
            padding: 1.5rem 2rem;
            text-align: center;

            .support-spotlight-featured-card__eyebrow {
              width: 100%;
              color: $ui-gray;
              margin-bottom: 1rem;

              :global(span) {
                font-size: 0.75rem;
              }
            }

            .support-spotlight-featured-card__description {
              margin-top: 1.25rem;

              :global(span) {
                font-weight: 400;
              }
            }

            .support-spotlight-featured-card__legend {
              margin-top: 1.5rem;
            }
          }
        }

        :global(.support-spotlight-featured-card .video-player-wrapper) {
          // for safari border radius bug
          -webkit-mask-image: -webkit-radial-gradient(white, black);
          backface-visibility: hidden;
          border-radius: 1.5625rem;
        }

        @media (${mq.laptop}) {
          .support-spotlight-featured-card {
            flex-direction: row;

            &__right-side {
              padding: 2.25rem 3rem;
              text-align: left;
            }
          }
        }

        @media (${mq.desktopLg}) {
          .support-spotlight-featured-card {
            &__right-side {
              padding: 3.125rem 4.375rem;
            }
          }

          :global(.support-spotlight-featured-card__right-side
              .support-spotlight-featured-card__title
              span) {
            font-size: 2.5rem;
          }

          :global(.support-spotlight-featured-card__right-side
              .support-spotlight-featured-card__eyebrow
              span) {
            font-size: 0.9375rem;
          }
        }
      `}</style>
    </>
  )
}

export default SupportSpotlightFeaturedCard
